@if (pagination.totalPages > 1) {
  <div class="category-pagination fx-row fx-row-h-center fx-row-v-center">
    @for (control of pagination.controls; track control) {
      <div class="category-pagination-item fx-col fx-col-v-center">
        @if (control.isArrow) {
          <a
            class="category-pagination-arrow fx-row fx-row-v-center fx-row-h-center"
            [class.disabled]="!control.isActive"
      (click)="
        control.isActive &&
          (control.direction == 'right'
            ? paginate(pagination.next.queryParams)
            : paginate(pagination.previous.queryParams))
      "
            >
            <mat-icon>{{ "chevron_" + control.direction }}</mat-icon>
          </a>
        }
        @if (control.isEllipsis) {
          <span class="category-pagination-ellipsis fx-row fx-row-h-center fx-row-v-center">
            &hellip;
          </span>
        }
        @if (control.isNumber) {
          <a
            class="category-pagination-number fx-row fx-row-h-center fx-row-v-center"
            [class.active]="control.isActive"
            (click)="paginate(control.queryParams)"
            >
            <span>{{ control.number }}</span>
          </a>
        }
      </div>
    }
  </div>
}
